import React from 'react';

type K = (e: KeyboardEvent | React.KeyboardEvent) => boolean;
type M = (e: MouseEvent | React.MouseEvent) => boolean;
export const isLeftMouseButtonEvent: M = (e): boolean => e.button === 0;
export const isWheelMouseButtonEvent: M = (e): boolean => e.button === 1;

const isKey =
  (...keys: string[]): K =>
  (e: KeyboardEvent | React.KeyboardEvent) =>
    keys.includes(e.key);

export const isEscapeKey = isKey('Escape');
export const isEnterKey = isKey('Enter');
export const isTabKey = isKey('Tab');
export const isControlKeyOn = (e: React.MouseEvent | React.KeyboardEvent): boolean => e.ctrlKey;
export const isCommandKeyOn = (e: React.MouseEvent | React.KeyboardEvent): boolean => e.metaKey;
export const isShiftKeyOn = (e: React.MouseEvent | React.KeyboardEvent): boolean => e.shiftKey;
export const isBackspaceKey = isKey('Backspace');
export const isShiftTabKey = (e: React.KeyboardEvent): boolean => isTabKey(e) && isShiftKeyOn(e);
export const isDeleteKey = isKey('Delete');
export const isNonNumericKey = (e: React.KeyboardEvent): boolean => Number.isNaN(parseInt(e.key, 10));
export const isClipboardActionKey = (e: React.KeyboardEvent): boolean =>
  isKey('a', 'c', 'v')(e) && (isControlKeyOn(e) || isCommandKeyOn(e));
